module.exports = __webpack_public_path__ + "752c93b22ace987350a310e2ea70e829.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-420.jpg
// module id = 510
// module chunks = 0